module.exports = __webpack_public_path__ + "img/horizontal_3_3_r_pp3_8004.5da742f6.png";